import { render, staticRenderFns } from "./systemOtherDetail.vue?vue&type=template&id=6fbd4d9c&scoped=true&"
import script from "./systemOtherDetail.vue?vue&type=script&lang=js&"
export * from "./systemOtherDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbd4d9c",
  null
  
)

export default component.exports